import React from 'react';
import {
    View,
    Image,
    Text,
    StyleSheet
} from 'react-native';
import PropTypes from 'prop-types';

import Colors from '../../../../constants/Colors';

const QuizTitleComponent = ({ title }) => {
    return (
        <View style={styles.questionBox}>
            <Image
                source={require('./img/questionMark.png')}
                style={styles.questionTag}
                resizeMode={'contain'}
            />

            <Text style={styles.title}>
                { title }
            </Text>
        </View>
    )
};

const styles = StyleSheet.create({
    questionBox: {
        backgroundColor: 'white',
        padding: 20,
        width: '90%',
        margin: 20,
        marginTop: 40,
        justifyContent: 'center',
        alignItems: 'center',
        borderWidth: 1,
        borderColor: Colors.borderColor,
    },
    questionTag: {
        width: 64,
        height: 64,
        marginTop: -48,
        // backgroundColor: 'white',
        borderRadius: 40,
    },
    title: {
        fontSize: 18
    }
});

QuizTitleComponent.propTypes = {
    title: PropTypes.string.isRequired,
};

export default QuizTitleComponent;
